import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    ReservationCancellationReasonService,
    ReservationCancellationReasonPopupService,
    ReservationCancellationReasonComponent,
    ReservationCancellationReasonDetailComponent,
    ReservationCancellationReasonDialogComponent,
    ReservationCancellationReasonPopupComponent,
    ReservationCancellationReasonDeletePopupComponent,
    ReservationCancellationReasonDeleteDialogComponent,
    reservationCancellationReasonRoute,
    reservationCancellationReasonPopupRoute,
    ReservationCancellationReasonResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...reservationCancellationReasonRoute,
    ...reservationCancellationReasonPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ReservationCancellationReasonComponent,
        ReservationCancellationReasonDetailComponent,
        ReservationCancellationReasonDialogComponent,
        ReservationCancellationReasonDeleteDialogComponent,
        ReservationCancellationReasonPopupComponent,
        ReservationCancellationReasonDeletePopupComponent,
    ],
    entryComponents: [
        ReservationCancellationReasonComponent,
        ReservationCancellationReasonDialogComponent,
        ReservationCancellationReasonPopupComponent,
        ReservationCancellationReasonDeleteDialogComponent,
        ReservationCancellationReasonDeletePopupComponent,
    ],
    providers: [
        ReservationCancellationReasonService,
        ReservationCancellationReasonPopupService,
        ReservationCancellationReasonResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiReservationCancellationReasonModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason.module.ts